import { render, staticRenderFns } from "./BtnCreate.vue?vue&type=template&id=4fe75721&"
import script from "./BtnCreate.vue?vue&type=script&lang=js&"
export * from "./BtnCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports